{
    "name": "centeralized-customer-registration",
    "version": "5.0.6",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port=8081",
        "build": "rimraf dist && ng build",
        "build:integration": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=integration",
        "build:staging": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=staging",
        "build:prod": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=production",
        "postbuild:integration": "yarn run postbuild",
        "postbuild:staging": "yarn run postbuild",
        "postbuild:prod": "yarn run postbuild",
        "postbuild": "node tools/fix-empty-chunks.mjs dist && (find dist -type f -name '*.js' -size 0 -print -quit | grep -q . && echo 'ERROR: unexpected 0B JS after patch' 1>&2 && exit 1 || echo '✅ no 0B JS left')",
        "test": "yarn audit",
        "test:visual:baseline": "direnv exec . bash -lc 'BASE_URL=$BASE_URL_PROD AUTH_REFRESH=1 npx playwright test tests/visual.spec.ts --update-snapshots'",
        "test:visual": "direnv exec . bash -lc 'BASE_URL=$BASE_URL_LOCAL AUTH_REFRESH=1 npx playwright test tests/visual.spec.ts'",
        "test:visual:report": "direnv exec . bash -lc 'NPM_CONFIG_LOGLEVEL=error npx --yes playwright show-report'",
        "lint": "tsc --noEmit --project tsconfig.app.json && eslint . && prettier --check 'src/**/*.html'",
        "prettier": "prettier --write 'src/**/*.{ts,js,css,html}'",
        "clean": "rimraf node_modules doc dist tmp reports && npm cache clean --force",
        "clean-install": "npm run clean && npm install",
        "clean-start": "npm run clean-install && npm start",
        "qa:clean": "rimraf node_modules",
        "qa": "npm install rimraf -g && npm run qa:clean && npm install && npm run start:qa"
    },
    "private": true,
    "dependencies": {
        "@angular-eslint/eslint-plugin-template": "^20.1.1",
        "@angular-eslint/template-parser": "^20.1.1",
        "@angular/animations": "20.3.0",
        "@angular/cdk": "^20.1.5",
        "@angular/common": "20.3.0",
        "@angular/compiler": "20.3.0",
        "@angular/core": "20.3.0",
        "@angular/flex-layout": "15.0.0-beta.42",
        "@angular/forms": "20.3.0",
        "@angular/localize": "^20.3.0",
        "@angular/material": "^20.1.5",
        "@angular/material-moment-adapter": "^20.1.5",
        "@angular/platform-browser": "20.3.0",
        "@angular/platform-browser-dynamic": "20.3.0",
        "@angular/router": "20.3.0",
        "@ngx-translate/core": "^15.0.0",
        "@ngx-translate/http-loader": "^8.0.0",
        "@popperjs/core": "^2.11.8",
        "@types/ineum": "^216.0.3",
        "@typescript-eslint/utils": "^8.0.0",
        "@vi-succ/design-system-web": "1.3.0",
        "@vi/fe-bell": "^1.0.1",
        "@vi/global-header": "15.3.3",
        "bootstrap": "5.3.8",
        "core-js": "^3.45.0",
        "countries-list": "^3.1.1",
        "dayjs": "^1.11.13",
        "deepmerge-ts": "^5.1.0",
        "google-libphonenumber": "^3.2.42",
        "i18n-iso-countries": "^4.3.1",
        "moment": "^2.29.4",
        "ng-recaptcha-2": "^16.0.1",
        "ngx-feature-toggle": "^12.0.0",
        "ngx-iban-validator": "^1.2.2",
        "ngx-image-cropper": "^9.1.5",
        "ngx-panzoom": "^19.0.0",
        "ngx-pipes": "^3.2.2",
        "ngx-toastr": "^19.0.0",
        "ngx-translate-multi-http-loader": "^17.0.0",
        "popper.js": "^1.15.0",
        "rxjs": "^7.8.1",
        "socket.io-client": "^4.8.1",
        "trim-right": "^2.0.0",
        "tslib": "^2.3.0",
        "underscore": "^1.13.7",
        "ws": "^8.18.3",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.0",
        "@angular-eslint/eslint-plugin": "^20.1.1",
        "@angular/cli": "20.3.0",
        "@angular/compiler-cli": "20.3.0",
        "@angular/language-service": "20.3.0",
        "@everest/codestyle": "^2.0.1",
        "@everest/eslint-config": "^9.2.6",
        "@playwright/test": "^1.56.0",
        "@types/jasmine": "~3.6.3",
        "@types/jasminewd2": "^2.0.8",
        "@types/node": "^16.7.1",
        "@typescript-eslint/eslint-plugin": "^8.39.1",
        "@typescript-eslint/parser": "^8.39.1",
        "eslint": "^9.33.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-import-resolver-typescript": "^3.6.1",
        "eslint-plugin-chai-expect": "^3.0.0",
        "eslint-plugin-import": "^2.29.1",
        "eslint-plugin-mocha": "^10.4.1",
        "eslint-plugin-prettier": "^5.1.3",
        "eslint-plugin-promise": "^6.1.1",
        "eslint-plugin-rulesdir": "^0.2.2",
        "eslint-plugin-sonarjs": "^3.0.4",
        "eslint-plugin-unicorn": "^52.0.0",
        "jasmine-core": "5.9.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "prettier": "^3.2.5",
        "prettier-eslint": "^16.3.0",
        "run-sequence": "2.2.1",
        "ts-node": "~7.0.0",
        "typescript": "5.8.3"
    },
    "resolutions": {
        "@babel/runtime": ">=7.26.10",
        "brace-expansion": ">=1.1.12",
        "esbuild": ">=0.25.0",
        "glob": ">=10.5.0",
        "http-proxy-middleware": ">=2.0.9",
        "js-yaml": ">=4.1.1",
        "on-headers": "^1.1.0",
        "send": ">=0.19.0",
        "serve-static": ">=1.16.0",
        "tar": ">=7.5.2",
        "tmp": ">=0.2.4",
        "undici": ">=7.5.0",
        "vite": ">=7.1.11",
        "webpack-dev-server": ">=5.2.1"
    }
}
